<template>
    <el-col :lg="14" :sm="14" :xs="24">
    
        <h1 class="">Welcome , Login HERE</h1>
        <el-card class="mb-20">
            <div class="text-center p-20 d-none">
                <img src="~@/assets/images/Logo.svg" alt="" class="k" width="200">
            </div>
            <el-form
                ref="ruleFormRef"
                :model="loginForm"
                status-icon
                label-width="120px"
                label-position="top"
                class="demo-ruleForm"
            >
                <el-form-item label="userName" prop="userName">
                    <el-input v-model="loginForm.userName" type="userName" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Password" prop="pass">
                    <el-input v-model="loginForm.password" type="password" autocomplete="off" show-password />
                </el-form-item>
            
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleFormRef')">Submit</el-button>
                    <!-- <el-button @click="resetForm('ruleFormRef')">Reset</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>
        <router-link to="/admin/reset-password"  class="no-decoration color-brown">
            forget password ?
        </router-link>
    </el-col>
</template>

<script>


export default {
    data(){
        return {
            
            loginForm:{
                userName:  "" ,
                // password:  "t-$U88741y",
                password:  ""
            }
        }
    },
    methods:{
        async submitForm(){
            const response = await this.$store.dispatch('adminLogin',this.loginForm);
            if (response.status == 1 ){
                localStorage.setItem('awsatLoggedIn',true)
                await localStorage.setItem('access_token',response.data.token)
                // await this.$store.dispatch('getMessages',0);
                this.$store.dispatch('setUser',response.data.profile)
                // await this.$store.dispatch('getAllSettings')
                await this.$store.dispatch('getAllLanguages')
                setTimeout(() => {
                    this.$router.push({name:'home-facts'})
                }, 300);
            }
        },
    }
}
</script>